import { ITransferMajorsDatasource } from './../datasources/transfer_majors_datasource';
import { SelectionListServant } from './../../global/servants/selection_list_servant';
import { IProgression, IProgressionConstructor } from 'utility-js-progression';

angular
  .module('capability-ng-transfer')
  .factory('ngTransferCreditsProgression', function ngTransferCreditsProgression(
    ngProgression: IProgressionConstructor,
    ngTransferMajorsDatasource: ITransferMajorsDatasource,
    ngSelectionListServant: SelectionListServant
  ): IProgression {
    return new ngProgression({
      major: {
        key: 'major',
        displayName: '',
        status(): string {
          return ngSelectionListServant.toString(ngTransferMajorsDatasource.model.majorsSelection);
        }
      },
      past: {
        key: 'past',
        displayName: '',
        _validationSource(): void {
          return undefined;
        },
        status(): string {
          return '';
        }
      },
      exam: {
        key: 'exam',
        displayName: '',
        _validationSource(): void {
          return undefined;
        },
        status(): string {
          return '';
        }
      },
      refine: {
        key: 'refine',
        displayName: 'Refine Estimate',
        _validationSource(): void {
          return undefined;
        },
        status(): string {
          return '';
        }
      },
      summary: {
        key: 'summary',
        displayName: 'Summary',
        _validationSource(): void {
          return undefined;
        },
        status(): string {
          return '';
        }
      }
    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/progression/transfer_credits_progression.ts